module.exports = __webpack_public_path__ + "static/media/image-1x1.fcab7c77.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/image-1x1.png
// module id = 254
// module chunks = 0